import {
  Box,
  ChakraProvider,
} from "@chakra-ui/react"
import theme from "./theme";
import NavBar from "./components/Navbar";
import Hero from "./components/Hero";
import Footer from "./components/Footer";
import Features from "./components/Features";
import Partners from "./components/Partners";
import Faq from "./components/Faq";
import Community from "./components/Community";

export const App = () => (
  <ChakraProvider theme={theme}>
    <Box as='header' w='100%' position="fixed" order={'top'} zIndex='1'>
      <NavBar></NavBar>
    </Box>
    <Box id="/" bg={'yellow.50'}>
      <Hero></Hero>
    </Box>
    <Box id="feature">
      <Features></Features>
    </Box>
    <Box id="faq" bg={'yellow.50'}>
      <Faq></Faq>
    </Box>
    {/* <Box id="team">
      <Team></Team>
    </Box> */}
    <Box id="partners">
      <Partners></Partners>
    </Box>
    <Box id="community">
      <Community></Community>
    </Box>
    <Footer></Footer>
  </ChakraProvider>
)
